export default __webpack_public_path__ + "static/media/image-spinner.7563dfae.gif";